<template>
    <div class="step">
        <div class="order" :style="configStyles.primary.background">
            {{ order }}
        </div>
        <div class="text">
            <h4>{{ step.title }}</h4>
            <small>{{ step.description }}</small>
        </div>
    </div>
</template>
<script>
import { SolutionConsumer } from '../../mixins';

export default {
    name: 'BriefStep',
    mixins: [SolutionConsumer],
    props: {
        order: {
            type: Number,
            required: true,
        },
        step: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

.step {
    @include card(20px);
    display: flex;
    align-items: center;

    > .order {
        @include square(40px);
        margin-right: 20px;
        border-radius: 50%;
        background-color: $black;
        color: $white;
        font-weight: bold;
        // Center number
        @include flex-vertical();
        justify-content: center;
        align-items: center;
        user-select: none;
    }

    > .text {
        flex: 1;
    }
}
</style>
